// extracted by mini-css-extract-plugin
export var container = "form-module--container--99+qh";
export var head = "form-module--head--xmgBN";
export var btnOuter = "form-module--btnOuter--VT9o0";
export var btn = "form-module--btn--E8LVL";
export var small = "form-module--small--dV3bB";